import { faGithub } from '@fortawesome/free-brands-svg-icons';
import {
  faHeart,
  faGraduationCap,
  faBuildingColumns,
  faAward,
  faBug,
} from '@fortawesome/free-solid-svg-icons';
import GithubRepoCount from './GithubRepoCount';

export const data = {
    introData: {
        intro: "Hello, World.",
        introDescription: "I make things happen with bits and bytes.",
        name: "Matt Verlee",
        firstName: "Matt",
        introButtonText: "Meet Me",
    },
    socialData: {
        socials: [
            {
                "id": "github",
                "link": "https://github.com/doubleangels",
            },
            {
                "id": "phone",
                "link": "#contact",
            },
            {
                "id": "email",
                "link": "#contact",
            }
        ],
    },
    statsData: {
        stats: [
            { icon: faHeart, text: 'Passion', content: 1 },
            { icon: faGraduationCap, text: 'Degree', content: 1 },
            { icon: faBuildingColumns, text: 'Learning', content: <span>&#8734;</span> },
            { icon: faGithub, text: 'Repos', content: <GithubRepoCount /> },
            { icon: faAward, text: 'Certs', content: 7 },
            { icon: faBug, text: 'Bugs', content: 0 },
        ],
    },
    profileData: {
        profileDescription: "I'm a cybersecurity analyst and developer with a passion for building secure, efficient solutions!",
    },
    educationData: {
        educationTitle: "Education",
        education: [
            {
                "degree": "Bachelor's of Science in Computer Science",
                "institution": "Colorado Mesa University",
                "year": "August 2014 - June 2018"
            },
            {
                "degree": "Bachelor of Science in Cybersecurity",
                "institution": "Southern New Hampshire University",
                "year": "Expected May 2026"
            }
        ],
    },
    certificationsData: {
        certificationsTitle: "Certifications",
        certifications: [
            "A+ - CompTIA (2020)",
            "Network+ - CompTIA (2020)",
            "Server+ - CompTIA (2020)",
            "Introduction to CS and Programming using Python - MITx (2018)",
            "Community Emergency Response Team (CERT) - Federal Emergency Management Agency (2018)",
            "Linux Essentials - Linux Professional Institute (2017)"
        ],
    },
    skillsData: {
        skillsDescription: "My expertise spans multiple technical domains, continuously refined through hands-on experience and dedicated professional development. There's always more to learn!",
        skills: [
            {
                "text": "Problem Solving",
            },
            { 
                "text": "Communication Skills",
            },
            { 
                "text": "Adaptability",
            },
            { 
                "text": "Technical Proficiency",
            },
            { 
                "text": "Security Practices",
            },
            { 
                "text": "Network Architecture",
            },
            { 
                "text": "Virtualization",
            },
            { 
                "text": "Full Stack Development",
            }
        ],
    },
    resumeData: {
        resumeDescription: "My career journey has equipped me with diverse technical expertise across cybersecurity, support, and development domains.",
        resume: [
            {
                "job": "Freelance Developer",
                "date": "November 2016 - Present",
                "company": "Self-Employed",
                "location": "Denver, CO",
                "responsibilities": [
                    "Architected custom software solutions for 10+ clients using modern technology stacks, delivering applications that improved operational efficiency by an average of 40%",
                    "Published privacy-focused Android applications with 650,000+ downloads and 4.3-star rating, achieving 9% month-over-month active user growth",
                    "Engineered and deployed a distributed file-sharing platform supporting multi-location collaboration, reducing file transfer times by 30% and improving team productivity",
                ]
            },
            {
                "job": "Customer Success Engineer",
                "date": "March 2025 - January 2026",
                "company": "Cohesity",
                "location": "Remote",
                "responsibilities": [
                    "Delivered technical guidance for Cohesity's cloud data management platform to 30+ enterprise customers, optimizing backup and recovery operations",
                    "Drove cross-functional collaboration with Support, Engineering, and Product teams to resolve 50+ critical escalations, achieving 98% customer satisfaction",
                    "Executed Customer Success Plans that increased product adoption by 45% and aligned platform utilization with customer business objectives",
                ]
            },
            {
                "job": "Junior Cybersecurity Analyst",
                "date": "April 2022 - March 2025",
                "company": "Open Raven",
                "location": "Remote",
                "responsibilities": [
                    "Partnered with enterprise clients on security assessments and remediation initiatives, strengthening infrastructure protection across cloud and on-premises environments",
                    "Created comprehensive security documentation and runbooks that improved incident response times by 40% and standardized protocols across 20+ client environments",
                    "Conducted root cause analysis for critical security incidents, implementing preventative controls that reduced client vulnerability exposure by 35%",
                ]
            },
            {
                "job": "Technical Support Analyst III",
                "date": "January 2022 - April 2022",
                "company": "American Civil Liberties Union",
                "location": "Denver, CO",
                "responsibilities": [
                    "Resolved mission-critical technical issues for 500+ staff members supporting civil liberties advocacy across 50+ state affiliates",
                    "Authored 15+ knowledge base articles that reduced recurring support tickets by 20% and improved user self-service capabilities",
                    "Designed and implemented technical solutions for complex organizational challenges, minimizing disruption to time-sensitive advocacy operations",
                ]
            },
            {
                "job": "Technical Support Assistant",
                "date": "April 2015 - October 2016",
                "company": "Fleet Financial",
                "location": "Englewood, CO",
                "responsibilities": [
                    "Deployed and maintained operating systems and enterprise applications across 50+ workstations, ensuring 99% uptime",
                    "Resolved 30+ support tickets daily using ITIL-based ticketing systems, maintaining a 95% first-call resolution rate",
                    "Diagnosed and resolved hardware, software, and network issues, reducing average ticket resolution time by 25%",
                ]
            },
        ],
    },
    portfolioData: {
        portfolioDescription: "Explore my technical projects showcasing problem-solving capabilities and coding expertise.",
    },
    projectData: {
        projects: [
            {
                "title": "Redact",
                "description": "Advanced media redaction tool that automatically detects and removes sensitive information from images and videos, ensuring complete data privacy and compliance.",
                "link": "https://github.com/doubleangels/redact",
            },
            {
                "title": "NextDNS Manager",
                "description": "Popular Android application providing intuitive mobile management of NextDNS configurations, trusted by over 100,000 users for enhanced privacy and security.",
                "link": "https://github.com/doubleangels/nextdnsmanager",
            },
            {
                "title": "J3Copy",
                "description": "Enterprise-grade real-time file synchronization platform designed to streamline collaboration across distributed engineering teams and multiple office locations.",
                "link": "https://github.com/mtverlee/j3Copy",
            }
        ],
    },
    contactData: {
        contactTitle: "Contact",
        contactLead: "Let's connect and explore how we can work together!",
        contactButtonText: "Reach Out",
        contactInformation: [
            {
                "id": "location",
                "type": "Location",
                "text": "Denver, CO",
                "link": "https://wikipedia.org/wiki/Denver"
            },
            {
                "id": "email",
                "type": "Email",
                "text": "matt@doubleangels.dev",
                "link": "mailto:matt@doubleangels.dev"
            },
            { 
                "id": "phone",
                "type": "Call/Text",
                "text": "(720) 505-9472",
                "link": "tel:7205059472"
            }
        ],
    },
};
